import { Controller } from "@hotwired/stimulus";

export class TelInputController extends Controller {
  sanitize() {
    this.element.value = this.element.value.replace(/\D+/g, "");
  }

  keydown(event) {
    const allowed = new Set([
      "Backspace",
      "Delete",
      "ArrowLeft",
      "ArrowRight",
      "Tab",
      "Home",
      "End",
    ]);

    if (allowed.has(event.key)) return;

    if (
      (event.ctrlKey || event.metaKey) &&
      ["a", "c", "v", "x"].includes(event.key.toLowerCase())
    ) {
      return;
    }

    if (!/^\d$/.test(event.key)) event.preventDefault();
  }
}
